const messages = {
  placeholder: {
    id: 'admin/promotions.form.scope.brands.select.placeholder',
  },
  label: {
    id: 'admin/promotions.form.scope.brands.select.label',
  },
}

export default messages
